const all = ['transcriptionAI']
const start = [...all, 'start']
const check = [...all, 'check']
const detail = (uuid: string) => [...all, uuid]

export const transcriptionAIKeys = {
  all,
  start,
  check,
  detail,
}
